import createConfig from '~/plugins/config/config';

// > Config global instance
const configInstance = createConfig();

export default configInstance;
